import * as z from 'zod';

export const schemaV1 = z.object({
  version: z.literal(1),
  data: z.object({
    category: z.object({
      selectedId: z.string(),
      expandedKeys: z.string().array(),
    }),
    extension: z.object({
      selectedIds: z.string().array(),
      expandedKeys: z.string().array(),
    }),
    finder: z.object({
      detailsVisible: z.boolean(),
    }),
    project: z.object({
      selectedId: z.number(),
    }),
    search: z.object({
      text: z.string(),
    }),
    sorting: z.object({
      order: z.union([z.literal('asc'), z.literal('desc')]),
      fieldKey: z.union([
        z.literal('name'),
        z.literal('extension'),
        z.literal('created_at'),
        z.literal('updated_at'),
      ]),
    }),
    tag: z.object({
      selectedIds: z.number().array(),
      expandedMode: z.boolean(),
    }),
  }),
});
